module.exports = __webpack_public_path__ + "img/pr-12.b4b434f1.png";